export const WALLET_CONNECT_WARNING = 'Connect wallet to make it rain'
export const MARKET_CLOSE_WARNING = 'This market is currently closed.'
export const SWAP_REFUND_WARNING = "⚠️ Swap failed. Funds refunded to your smart Account."
export const SWAP_PROCESSING_WARNING = "Swapping funds... This may take a moment."
export const SWAP_FINALIZED_WARNING = "Finalizing transaction..."
export const LOGIN_SUCCESS = "You're in. Get predicting!"
export const PROFILE_UPDATE_SUCCESS = "Profile Updated"
export const FUNDS_RECIEVED_SUCCESS = "Funds received in your wallet"
export const TRADE_PLACED_SUCCESS = "Success. the trade before the storm!"
export const GAS_FEES_ERROR = "Need more gas to spark the lightning"
export const SOLVENCY_LIMIT_ERROR = "Can't perform this action because the USD protocol is at its solvency limit."
export const DEFAULT_ERROR_HEADING = "Something went wrong"
export const ERROR_GENERATING_DEPOSIT_ADDRESS = "Error generating deposit address. Please try again"
export const ERROR_GENERATING_BTC_ADDRESS = "Refund WalletAddress is not a valid BTC (Native SegWit) address"
export const SAFE_FUNDS_WARNING = "Your funds are safe now"

